import {
  SETTINGS_PAYMENT_HISTORY,
  SETTINGS_PAYMENT_HISTORY_SUCCEEDED,
  SETTINGS_PAYMENT_HISTORY_FAILED,
  CLEAR_SETTINGS_PAYMENT_HISTORY,
  RECURRING_PAYMENT,
  RECURRING_PAYMENT_FAILED,
  RECURRING_PAYMENT_SUCCEEDED,
  LOAD_PROFILE_DETAILS_SUCCEEDED,
  LOAD_PROFILE_DETAILS_FAILED,
  UPDATE_PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS_SUCCEEDED,
  UPDATE_PROFILE_DETAILS_FAILED,
  PROFILE_HANDLE_CHANGE,
  PASSWORD_HANDLE_CHANGE,
  UPDATE_PASSWORD_SUCCEEDED,
  CLEAR_PASSWORD,
  UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD, 
  USER_PAST_UPLOADS,
  USER_PAST_UPLOADS_SUCCEDED,
  CLEAR_USER_PAST_UPLOADS,
} from "../../common/constants";
import Session from "../../utility/session";

import { initialState } from "../BulkValidation/reducer";
const initailState = {
  profileInfo: {
    name: "",
    username: "",
    lastname: "",
    CompanyName: "",
    mobilenumber: "",
    city: "",
    country: "",
    address: "",
    zipcode: "",
    mmcustomerid: "",
    btnDisabled: false
  },
  passwordInfo: {
    oldpassword: "",
    newpassword: "",
    confirmpassword: "",
    username: Session.getItem(Session.CURRENT_USER_NAME),
    btnDisabled: false
  },
  pastUploads:{docs:[], page:1, limit:10, total:0, pages:1, loading: false},
  paymentHistory: {docs:[], page:1, limit:10, total:0, pages:1, loading: false},
  recurringPayment: []
};

export const settingsReducer = (state = initailState, action) => {
  switch (action.type) {
    case SETTINGS_PAYMENT_HISTORY:
      return {...state, paymentHistory: {...state.paymentHistory, loading: true}}
    case CLEAR_SETTINGS_PAYMENT_HISTORY:
      return {...state, paymentHistory: initailState.paymentHistory}
    case SETTINGS_PAYMENT_HISTORY_SUCCEEDED:
      return { ...state, paymentHistory: {...action.paymentHistory, loading: false, docs: state.paymentHistory.docs.concat(action.paymentHistory.docs)} };
    case LOAD_PROFILE_DETAILS_SUCCEEDED:
      return { ...state, profileInfo: action.profileInfo };
    case UPDATE_PROFILE_DETAILS:
      return {
        ...state,
        profileInfo: { ...action.profileInfo, btnDisabled: true }
      };
    case UPDATE_PROFILE_DETAILS_SUCCEEDED:
      return { ...state, profileInfo: action.profileInfo };
    case UPDATE_PASSWORD_SUCCEEDED:
      return { ...state, passwordInfo: initailState.passwordInfo };
    case UPDATE_PASSWORD_FAILED:
      return { ...state, passwordInfo: initailState.passwordInfo };
    case UPDATE_PASSWORD:
      return {
        ...state,
        passwordInfo: { ...initailState.passwordInfo, btnDisabled: true }
      };
    case PROFILE_HANDLE_CHANGE:
      return {
        ...state,
        profileInfo: { ...state.profileInfo, [action.name]: action.value }
      };
    case PASSWORD_HANDLE_CHANGE:
      return {
        ...state,
        passwordInfo: { ...state.passwordInfo, [action.name]: action.value }
      };
    case CLEAR_PASSWORD:
      return { ...state, passwordInfo: initailState.passwordInfo };
    case RECURRING_PAYMENT_SUCCEEDED:
      return { ...state, recurringPayment: action.recurringpayment };
    case USER_PAST_UPLOADS: {
      return {...state, pastUploads: {...state.pastUploads, loading: true}}
    }
    case USER_PAST_UPLOADS_SUCCEDED:
      return {...state, pastUploads: {...action.uploadHistory, loading: false, docs: state.pastUploads.docs.concat(action.uploadHistory.docs)}}
    case CLEAR_USER_PAST_UPLOADS: 
      return {...state, pastUploads: initailState.pastUploads}
    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/Containers/Settings/reducer.js